import AdminArea from "./Admin/AdminArea";
import FirstSteps2 from "./FirstSteps2/FirstSteps2";
function Home() {
  return (
    <div className="text-center">
      <AdminArea />
      <FirstSteps2 />
    </div>
  );
}

export default Home;
